export default `Эффект длится до окончания действия яда грунга.

Яд грунга теряет свои свойства через 1 минуту после отделения от него. Тот же процесс происходит и после смерти грунга.`
